import i18n from '../../i18n/i18n';
import moment from 'moment-timezone';

const useDateFormat = ({ date, event = null, organization = null, dateStyle, timeStyle }) => {
    const locale = i18n.language;
    const timeZone = organization?.timezone || event?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;

    if (!date) {
        date = moment();
    }

    const dateWithDay = new Date(date).toLocaleDateString(locale, {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        timeZone
    });

    const properDate = new Date(date).toLocaleDateString(locale, {
        dateStyle,
        timeZone
    });

    const properTime = new Date(date).toLocaleTimeString(locale, {
        timeStyle,
        timeZone
    });

    return [dateWithDay, properTime, properDate];
};

export default useDateFormat;
